<template>
  <div class="dashboard-editor-container">
    <panel-group order-manage-url="/tms/transportManage/waybillManage" />
    <el-row :gutter="20">
      <el-col :span="12">
        <div class="first-title">
          运价指数
        </div>
      </el-col>
      <el-col :span="12">
        <div class="first-title">
          运费统计
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <HomeLineChart :chart-data="chartData" />
      </el-col>
      <el-col :span="12">
        <FreightStatistics />
      </el-col>
    </el-row>
    <el-row />
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="first-title">
          货源大厅
        </div>
      </el-col>
    </el-row>
    <el-row class="backSupplyHall">
      <SupplyHall class="supply-hall" />
    </el-row>
  </div>
</template>

<script>
  import PanelGroup from './components/PanelGroupDriver'
  import HomeLineChart from './components/homeLineChart'
  import FreightStatistics from './components/freightStatistics'
  // import PieChart from './components/PieChart'
  // import plat from './components/plat.vue'
  // import BarChart from './components/BarChart'
  import SupplyHall from '@/views/tms/order/hall/index'

  export default {
    name: 'DashboardAdmin',
    components: {
      PanelGroup,
      // PieChart,
      // BarChart,
      // plat,
      FreightStatistics,
      HomeLineChart,
      SupplyHall
    },
    data() {
      return {
        chartData:{

        }
      }
    },
    methods: {

    }
  }
</script>
<style lang="scss" type="text/scss">
  .supply-hall{
    .vxe-footer--row .vxe-footer--column.col--ellipsis{
      border-right: 0px;
      height: 32px;
    }
    .vxe-footer--row {
      background-color: #f1f1f1;
    }
    .vxe-table .vxe-body--column.col--ellipsis {
      height: 38px;
    }
    .vxe-toolbar{
      padding: 0px 0px 0px 10px;
    }
  }
</style>
<style lang="scss" scoped>
  .backSupplyHall.el-row {
    background:#FFFFFF;
  }
  .first-title {
    position: relative;
    top:5px;
    padding-left: 14px;
    font-size: 16px;
    line-height: 50px;
    height: 50px;
    border-bottom: none;

    i {
      margin-right: 8px;
    }
  }

  .first-title::before {
    content: '';
    height: 15px;
    width: 4px;
    background-color: #FF7F21;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  ._website {
    width: 100%;
    height: 300px;
    position: relative;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;

    ._txt {
      color: #666666;
      font-size: 14px;
      font-weight: 600;
      padding-left: 20px;
      position: absolute;
      top: 30px;
      left: 0;
      z-index: 9;
    }

    ._websiteImg {
      width: 100%;
    }
  }

  .my-icon {
    height: 300px;
  }

  .dashboard-editor-container {
    padding: 32px;
    background-color: rgb(240, 242, 245);
    position: relative;

    .github-corner {
      position: absolute;
      top: 0px;
      border: 0;
      right: 0;
    }

    .chart-wrapper {
      background: #fff;
      padding: 16px 16px 0;
      margin-bottom: 32px;
    }
  }

  @media (max-width:1024px) {
    .chart-wrapper {
      padding: 8px;
    }
  }

  .title {
    font-size: 16px;
  }

  .container {
    border-radius: 4px;
    // margin: 0 20px;
    padding: 4px;
  }

  .tool-button-container {
    .el-col {
      text-align: center;

      button {
        width: 80%;
      }
    }
  }

  .plat-data-container {
    background-color: #FFFFFF;

    .data-container {
      background-color: #fff;
      padding: 4px;
      border-radius: 4px;
      font-size: 14px;

      .text-center {
        text-align: center;
      }
    }

    .first-title {
      padding-left: 5px;
      font-size: 18px;
      line-height: 50px;
      // height: 50px;
      border-bottom: none;

      i {
        margin-right: 8px;
      }
    }

    .second-title {
      margin-left: 16px;
      overflow: hidden;
      font-size: 14px;
      color: #000000;
      line-height: 32px;
      padding: 10px 0 10px 5px;

      i {
        margin-right: 6px;
      }
    }

    .data-title {
      padding: 5px;
      font-size: 14px;
      color: #78909C;
      display: block;
      margin-top: 10px;
    }

    .data-val {
      font-size: 24px;
      color: #000033;
      display: block;
      font-weight: 200;
      padding: 5px;
    }
  }

  .split-line-container {
    position: relative;

    .split-line {
      display: inline-block;
      width: 1px;
      height: 3em;
      vertical-align: middle;
      position: absolute;
      left: 0;
      background-color: #f0f2fa;
    }
  }

  .nav_bg1 {
    background: #0bb2d4;
  }

  .nav_bg2 {
    background: #ff7f21;
  }

  .nav_bg3 {
    background: #677afa;
  }

  .nav_bg4 {
    background: #11c26d;
  }

  .nav_bg5 {
    background: #f4516c;
  }

  .shuju_nav_list {
    display: block;
    overflow: hidden;
    padding: 0 30px;
    height: 108px;
    border-radius: 4px;
    width: 80%;
    margin: auto;

    .shuju_i {
      display: block;
      border-radius: 50%;
      margin-top: 20px;
      float: left;
      width: 60px;
      height: 60px;
      border: 5px solid rgba(255, 255, 255, 0.3);

      i {
        display: block;
        border-radius: 50%;
        background: #ffffff;
        height: 100%;

        img {
          display: block;
          height: 75%;
          margin: 0 auto;
          padding-top: 25%;
        }
      }
    }

    .shuju_list_xinxi {
      float: left;
      margin-left: 20px;
      color: #fff;
      line-height: 108px;

      span {
        font-size: 1.2em;
        display: block;
      }
    }
  }
  .el-divider__text {
    background: #f0f2f5;
  }
</style>
